module.exports = __webpack_public_path__ + "static/media/logo.90ab8cc0.png";